import React, { useState, useEffect } from 'react';
// import { message } from 'antd';
// import { StarFilled, PictureOutlined } from '@ant-design/icons';
// import gallery from '@/common/assets/images/gallery.svg';
import star_filled from '@/common/assets/images/fullHeart.svg';
import star from '../../../common/assets/images/heart.svg';
import { useNavigate } from 'react-router-dom';
import profilePhoto from './images/Simplification.png';
// import { useDispatch } from 'react-redux';
// import { likeProfile, unlikeProfile } from '../redux/slice';

// import star_outlined from '../assets/star_outlined.svg';
// import { useNavigate } from 'react-router-dom';
// import './profiles.css';
import styles from './index.module.less';

const Profiles = ({ data, onProfileAction }) => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  // console.log('profiles_data', data?.profile_id);

  useEffect(() => {
    if (data.isFavourite) {
      setIsLiked(true);
    }
  }, [data.isFavourite]);

  const handleViewProfile = (id) => {
    // console.log('Calling view API with ID:', id);
    navigate(`/profileview/${id}`);
  };

  const handleLikeClick = (e, profileId) => {
    e.stopPropagation(); // Prevents triggering parent onClick
    const newLikedStatus = !isLiked;

    setIsLiked(newLikedStatus);
    // console.log('profileId:', profileId, 'Liked:', newLikedStatus);

    // Call the parent function and pass profileId & actionType
    onProfileAction(profileId, newLikedStatus ? 'like' : 'unlike');
  };

  return (
    <div>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={styles.cardOuter}
      >
        <div className={styles.cardOutline}>
          <div
            className={styles.cardInner1}
            style={{
              transform: isHovered ? 'scale(1.20)' : 'scale(1)',
              cursor: 'pointer'
            }}
            onClick={() => handleViewProfile(data.id)}
          >
            <img
              src={data.pic}
              alt={data.name}
              // className={styles.cardImage}
              className={`${styles.cardImage} ${
                data.pic === profilePhoto
                  ? styles.fallbackImg
                  : styles.profileImg
              }`}
            />
            {data.isNew && (
              // || data.isFavourite
              <div className={styles.cardNew}>
                {data.isNew && 'New '}
                {/* {data.isFavourite && 'Favourite'} */}
              </div>
            )}
            <div
              className={styles.cardIcons}
              // onClick={() => setIsLiked(!isLiked)}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* <img src={isLiked || isHovered ? star_filled : star} alt="star" /> */}
              <div
                // onClick={(e) => {
                //   e.stopPropagation(); // Prevents triggering parent onClick
                //   setIsLiked(!isLiked);
                // }}
                // onClick={handleLikeClick(data.id)}
                onClick={(e) => handleLikeClick(e, data?.profile_id)}
                style={{ cursor: 'pointer' }}
              >
                <img src={isLiked ? star_filled : star} alt="star" />
              </div>
            </div>
          </div>

          <div
            className={styles.cardOuter2}
            style={{
              backgroundColor: isHovered ? '#FF6200' : '#ff620033'
            }}
          >
            <div
              className={styles.cardInner2}
              style={{
                color: isHovered ? '#FDE6CD' : '#E05C2B',
                backgroundColor: isHovered ? '#FF6200' : 'transparent',
                borderBottom: isHovered
                  ? '1px solid white'
                  : '1px solid #E05C2B'
              }}
            >
              <span className={styles.cardInnerTitle}>{data.name}</span>
              <span className={styles.cardInnerSubTitle}>{data.code}</span>
            </div>
            <div
              className={styles.cardInnerDetails}
              style={{
                color: isHovered ? '#F8F0DC' : 'rgb(232 90 0 )',
                backgroundColor: isHovered ? '#FF6200' : 'transparent'
              }}
            >
              {/* <span className={styles.cardDetails}>
                {data.dob} yrs / {data.height}
              </span> */}
              {(data.dob || data.height) && (
                <span className={styles.cardDetails}>
                  {data.dob && `${data.dob}`}
                  {data.dob && data.height && ' / '}
                  {data.height && `${data.height}`}
                </span>
              )}
              <span className={styles.cardDetails}>{data.marriedStatus}</span>
              <span className={styles.cardDetails}>{data.address}</span>
              <span className={styles.cardDetails}>{data.occupation}</span>
              <span className={styles.cardDetails}>{data.education}</span>
              <span className={styles.cardDetails}>
                {data.income ? `Rs ${data.income}` : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profiles;
